export const helperMixin = {
  data() {
    return {
      clearSelectedStates: () => {
        const stateMutators = [
          { module: 'circuit', mutation: 'setSelectedCircuit' },
          { module: 'clientProgram', mutation: 'setSelectedWeek' },
          { module: 'clientProgram', mutation: 'setSelectedDay' },
          { module: 'clientProgram', mutation: 'setSelectedAllWeek' },
          { module: 'client', mutation: 'setSelectedClient' },
          { module: 'equipment', mutation: 'setSelectedEquipment' },
          { module: 'exercise', mutation: 'setSelectedExercise' },
          { module: 'exercise', mutation: 'setSelectedAltExercise' },
          { module: 'exercise', mutation: 'setSelectedStep' },
          { module: 'grocery', mutation: 'setSelectedItem' },
          { module: 'mediaUpload', mutation: 'setTempPhotoPreview' },
          { module: 'modal', mutation: 'setSelectedItem' },
          { module: 'trainer', mutation: 'setSelectedTrainer' },
          { module: 'workout', mutation: 'setSelectedWorkout' },
        ];

        stateMutators.forEach((sm) =>
          this.$store.commit(`${sm.module}/${sm.mutation}`, null)
        );
      },
    };
  },
  methods: {
    $_clearSelections() {
      this.clearSelectedStates();
    },
  },
};
